<template>
    <div class="schedule-container">
        <div ref="scheduleDropdownRef" class="dropdown">
          <van-sticky>
            <van-dropdown-menu active-color="#337ECC">
              <van-dropdown-item v-model="groupValue" :options="groupOptions" @change="onGroupChange" />
              <van-dropdown-item
                v-model="roundValue"
                :options="roundOptions"
                :disabled="!groupValue"
                @change="onRoundChange"
              />
            </van-dropdown-menu>
          </van-sticky>
        </div>
        <div
          class="schedule-body"
          :style="scheduleBodyMinHeightStyle"
        >
          <van-pull-refresh
            v-model="refreshing"
            :disabled="finishedPast"
            class="schedule-pull-refresh"
            @refresh="onLoadPast"
          >
            <van-list
              v-model="loading"
              :finished="finishedFuture"
              finished-text="没有更多了"
              :immediate-check="false"
              @load="onLoadFuture"
            >
              <div class="content">
                <Game v-for="game in games" :key="game.id" :game="game" />
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { DropdownMenu, DropdownItem, List, PullRefresh, Sticky } from 'vant';
Vue.use(DropdownMenu).use(DropdownItem).use(List).use(PullRefresh).use(Sticky);
import { getBMMatchList2, getBMStageGamesByBMMatchId, getBMUnionMatchGameList } from '@/api/match';
import Game from './components/game.vue';

const ORDER_TYPE_ANCHOR = 0
const PAGE_SIZE = 10

export default {
  components: {
    Game
  },
  computed: {
    scheduleBodyMinHeightStyle() {
      return this.scheduleBodyMinHeightPx ? { minHeight: this.scheduleBodyMinHeightPx } : {}
    }
  },
  data() {
    return {
      unionMatchId: '',
      groupValue: '',
      groupOptions: [
        { text: '全部组别', value: '' }
      ],
      roundValue: '',
      roundOptions: [
        { text: '全部轮次', value: '' }
      ],
      games: [],
      orderType: ORDER_TYPE_ANCHOR,
      pageSize: PAGE_SIZE,
      /** isDown=1 向未来翻页，从 1 递增 */
      futurePageNum: 1,
      /** isDown=0 向过去翻页，从 1 递增 */
      pastPageNum: 1,
      finishedFuture: false,
      finishedPast: false,
      loading: false,
      refreshing: false,
      pendingRequest: false,
      scheduleBodyMinHeightPx: ''
    };
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.getBMMatchList2();
    this.reloadScheduleList()
    this.$nextTick(() => {
      this.updateSchedulePullMinHeight()
      window.addEventListener('resize', this.updateSchedulePullMinHeight)
      window.addEventListener('orientationchange', this.onOrientationScheduleResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSchedulePullMinHeight)
    window.removeEventListener('orientationchange', this.onOrientationScheduleResize)
  },
  methods: {
    onOrientationScheduleResize() {
      setTimeout(() => this.updateSchedulePullMinHeight(), 200)
    },
    /** 赛程区域至少占满视口剩余高度，比赛少时在空白处也可下拉触发「更早」分页 */
    updateSchedulePullMinHeight() {
      this.$nextTick(() => {
        const el = this.$refs.scheduleDropdownRef
        if (!el || typeof el.getBoundingClientRect !== 'function') return
        const rect = el.getBoundingClientRect()
        const vh = window.innerHeight || document.documentElement.clientHeight
        const bottomPad = 12
        const minPx = Math.max(280, Math.floor(vh - rect.bottom - bottomPad))
        const next = `${minPx}px`
        if (next !== this.scheduleBodyMinHeightPx) {
          this.scheduleBodyMinHeightPx = next
        }
      })
    },
    /**  prepend 前置数据后补偿 scrollTop，使下拉前列表首条仍在视口内大致位置（van-list 默认视口滚动） */
    restoreViewportAfterPrepend(scrollSnapshot) {
      if (!scrollSnapshot) return
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.$nextTick(() => {
            const h = Math.max(
              document.documentElement.scrollHeight,
              document.body.scrollHeight
            )
            const delta = h - scrollSnapshot.scrollHeight
            window.scrollTo(0, scrollSnapshot.scrollTop + delta)
          })
        })
      })
    },
    getBMMatchList2() {
      getBMMatchList2({ unionMatchId: this.unionMatchId }).then(res => {
        const { data } = res
        this.groupOptions.push(...data.list.map(item => ({ text: item.group, value: item.id })));
      });
    },
    onGroupChange() {
      this.roundValue = '';
      this.roundOptions = [{ text: '全部轮次', value: '' }];
      this.getBMStageGamesByBMMatchId();
      this.reloadScheduleList()
    },
    onRoundChange() {
      this.reloadScheduleList()
    },
    getBMStageGamesByBMMatchId() { 
      if(!this.groupValue) return;
      getBMStageGamesByBMMatchId({ unionMatchId: this.unionMatchId, matchId: this.groupValue }).then(res => {
        const { data } = res
        const isGroupRound = data.isGroupRound
        const stages = data.stages
        var rounds = []
        if (isGroupRound === 1 && stages.length >= 1) {
          stages.forEach((item) => {
            for (let i = 1; i <= item.roundCount; i++) {
              let label = item.stageName + '第' + i + '轮'
              if (item.roundAliasList) {
                const obj = item.roundAliasList.find(a => a.round === i) || null
                if (obj) {
                  label = obj.alias
                }
              }
              rounds.push({
                index: i,
                stages: item.id,

                value: item.id + '_' + i,
                text: label
              })
            }
          });
        }
        this.roundOptions.push(...rounds);
      });
    },
    mapGameItem(item) {
      return {
        id: item.id,
        liveStatus: item.liveStatus,
        gameStatus: item.gameStatus,
        homeTeamId: item.homeTeamId,
        awayTeamId: item.awayTeamId,
        homeName: item.homeAlias || item.homeName,
        awayName: item.awayAlias || item.awayName,
        homeBadge: item.homeBadge || item.matchIcon,
        awayBadge: item.awayBadge || item.matchIcon,
        homeScore: item.homeScore == -1 ? '' : item.homeScore,
        awayScore: item.awayScore == -1 ? '' : item.awayScore,
        beginDate: item.beginDate,
        roundName: item.roundName,
        fieldName: item.fieldName,
        courtName: item.courtName,
        location: item.location,
        gameCourtName: item.gameCourtName,
        groupName: item.group || '',
        name: item.name || '',
        type: item.type,
        gameMode: item.gameMode
      }
    },
    /** 按开赛时间正序，保证 isDown=0 倒序接口与 isDown=1 正序接口合并后展示一致 */
    mergeGamesByTimeAsc(newRows) {
      const map = new Map(this.games.map(g => [g.id, g]))
      newRows.forEach(g => map.set(g.id, g))
      return Array.from(map.values()).sort((a, b) => {
        const ta = new Date(a.beginDate || 0).getTime()
        const tb = new Date(b.beginDate || 0).getTime()
        return ta - tb
      })
    },
    buildListParams() {
      let round = ''
      let stageId = ''
      if (this.roundValue) {
        round = this.roundValue.split('_')[1]
        stageId = this.roundValue.split('_')[0]
      }
      return {
        unionMatchId: this.unionMatchId,
        round,
        stageId,
        // accountId: 27509,
        orderType: this.orderType,
        pageSize: this.pageSize
      }
    },
    resetPagination() {
      this.games = []
      this.futurePageNum = 1
      this.pastPageNum = 1
      this.finishedFuture = false
      this.finishedPast = false
    },
    /** 筛选变化后重新从「未来」第一页拉取 */
    reloadScheduleList() {
      this.resetPagination()
      this.fetchFuturePage({ isInitial: true })
    },
    onLoadFuture() {
      this.fetchFuturePage({ isInitial: false })
    },
    /** 触底：orderType=0, isDown=1, pageNum 递增 */
    fetchFuturePage({ isInitial }) {
      if (this.pendingRequest || this.finishedFuture) {
        this.loading = false
        return
      }
      this.pendingRequest = true
      if (!isInitial) {
        this.loading = true
      }
      const params = {
        ...this.buildListParams(),
        orderType: ORDER_TYPE_ANCHOR,
        isDown: 1,
        pageNum: this.futurePageNum,
        matchId: this.groupValue,
      }
      getBMUnionMatchGameList(params)
        .then(res => {
          const list = (res.data && res.data.list) || []
          const rows = list.map(item => this.mapGameItem(item))
          this.games = this.mergeGamesByTimeAsc(rows)
          if (list.length < this.pageSize) {
            this.finishedFuture = true
          }
          if (list.length > 0) {
            this.futurePageNum += 1
          } else if (this.futurePageNum === 1) {
            this.finishedFuture = true
          }

          /** 首轮「未来」拉完后顺带预加载 1 页「过去」，与下拉参数一致（含 matchId）。
           *  静默预加载不恢复 scroll：避免 restoreViewportAfterPrepend 与 updateSchedulePullMinHeight 错位把 scrollTop 拉大（底部空白）。
           */
          if (isInitial && !this.finishedPast) {
            return this.$nextTick().then(() =>
              this.fetchPastGamePage(this.scrollSnapshotRestore(), { skipViewportRestore: true })
            )
          }
        })
        .then((pastMeta) => {
          if (
            pastMeta &&
            pastMeta.didAppendPast &&
            pastMeta.scrollSnapshot != null &&
            !pastMeta.skipViewportRestore
          ) {
            this.restoreViewportAfterPrepend(pastMeta.scrollSnapshot)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.pendingRequest = false
          this.loading = false
          this.updateSchedulePullMinHeight()
        })
    },
    scrollSnapshotRestore() {
      return {
        scrollHeight: Math.max(document.documentElement.scrollHeight, document.body.scrollHeight),
        scrollTop:
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0
      }
    },
    /**
     * 拉取一页更早赛程（与触底未来请求相同筛选：含 matchId、round/stage）。
     * @returns {Promise<{ didAppendPast: boolean, scrollSnapshot: object|null, skipViewportRestore: boolean }>}
     */
    fetchPastGamePage(scrollSnapshot, options = {}) {
      const skipViewportRestore = !!options.skipViewportRestore
      if (this.finishedPast) {
        return Promise.resolve({ didAppendPast: false, scrollSnapshot, skipViewportRestore })
      }
      const params = {
        ...this.buildListParams(),
        orderType: ORDER_TYPE_ANCHOR,
        isDown: 0,
        pageNum: this.pastPageNum,
        matchId: this.groupValue
      }
      let didAppendPast = false
      return getBMUnionMatchGameList(params).then(res => {
        const list = (res.data && res.data.list) || []
        const rows = list.map(item => this.mapGameItem(item)).reverse()
        this.games = this.mergeGamesByTimeAsc(rows)
        if (list.length < this.pageSize) {
          this.finishedPast = true
        }
        if (list.length > 0) {
          this.pastPageNum += 1
          didAppendPast = true
        } else if (this.pastPageNum === 1) {
          this.finishedPast = true
        }
        return { didAppendPast, scrollSnapshot, skipViewportRestore }
      })
    },
    /** 下拉刷新：orderType=0, isDown=0, pageNum 从 1 递增；接口时间倒序，翻转为正序后合并 */
    onLoadPast() {
      if (this.pendingRequest || this.finishedPast) {
        this.refreshing = false
        return
      }
      const scrollSnapshot = this.scrollSnapshotRestore()
      this.pendingRequest = true
      this.fetchPastGamePage(scrollSnapshot)
        .catch(() => {})
        .then((result = {}) => {
          if (
            result.didAppendPast &&
            result.scrollSnapshot != null &&
            !result.skipViewportRestore
          ) {
            this.restoreViewportAfterPrepend(result.scrollSnapshot)
          }
        })
        .finally(() => {
          this.pendingRequest = false
          this.refreshing = false
          this.updateSchedulePullMinHeight()
        })
    }
  },
};
</script>

<style lang="scss">
.van-sticky--fixed{
  padding: 12px 16px;
  background-color: #fff;
}
.schedule-container{
  .van-dropdown-menu__bar{
    background-color: #FFFFFF;

    .van-dropdown-menu__item + .van-dropdown-menu__item {
      margin-left: 12px;
    }
    box-shadow: none;
  }
  .van-dropdown-menu__title{
    width: 100%;
    box-sizing: border-box;
    .van-ellipsis{
      max-width: 90%;
      text-align: center;
      // padding: 0px;
    }
    
  }
  .van-dropdown-menu__title::after {
    right: 12px;
    border: 4px solid;
    border-color: transparent transparent #686B6F #686B6F;
  }
  .van-dropdown-menu__item{
  border-radius: 5px;
  background-color: #F4F4F5;
  }
  .van-dropdown-menu__title--active::after {
    border-color: transparent transparent currentColor currentColor !important;
  }
}
</style>
<style scoped lang="scss">
.schedule-container{
  padding: 12px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.schedule-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.schedule-pull-refresh {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.schedule-pull-refresh ::v-deep .van-pull-refresh__track {
  flex: 1;
  min-height: 100%;
}
</style>
